package com.fireavert.user.data_models

data class UserAuth(val id: Int, val token: String, val refresh: String, val roles: List<Role>) {
    val isValid: Boolean
        get() {
            return id != 0 &&
                    token.isNotBlank() &&
                    refresh.isNotBlank()
        }
}